import { Dashboard } from "./Dashboard";
import "./index.css";

export function App() {
    return <Dashboard />;
}

export default App;
